import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Slider, Stack, Typography, useTheme } from '@mui/material';
import { useStudyContext } from '../../../context';
const MARKS = [
    {
        value: 18,
        label: '18',
    },
    {
        value: 30,
        label: '',
    },
    {
        value: 40,
        label: '',
    },
    {
        value: 50,
        label: '',
    },
    {
        value: 60,
        label: '',
    },
    {
        value: 70,
        label: '',
    },
    {
        value: 80,
        label: '',
    },
    {
        value: 90,
        label: '90',
    },
];
const MIN_DISTANCE = 1;
const MAX_AGE = 90;
const MIN_AGE = 18;
export const AgeRangeSelector = () => {
    const theme = useTheme();
    const { studyPayload, updateAgeRangePayload, canCreateStudy } = useStudyContext();
    const sliderValues = [studyPayload === null || studyPayload === void 0 ? void 0 : studyPayload.minAge, studyPayload === null || studyPayload === void 0 ? void 0 : studyPayload.maxAge];
    const handleAgeRangeChange = (e, newRangeValues, activeThumbIndex) => {
        if (!Array.isArray(newRangeValues))
            return;
        const [selectedMinAge, selectedMaxAge] = newRangeValues;
        if (activeThumbIndex === 0) {
            const adjustedMinAge = Math.min(selectedMinAge, selectedMaxAge - MIN_DISTANCE);
            updateAgeRangePayload(adjustedMinAge, selectedMaxAge);
            return;
        }
        const adjustedMaxAge = Math.max(selectedMaxAge, selectedMinAge + MIN_DISTANCE);
        updateAgeRangePayload(selectedMinAge, adjustedMaxAge);
    };
    return (_jsxs(Stack, { gap: "15px", marginTop: "20px", children: [_jsxs(Typography, { fontSize: "12px", fontWeight: 700, letterSpacing: "0.17px", color: theme.palette.secondary.dark, children: ["Select Age Range: ", sliderValues[0], " - ", sliderValues[1]] }), _jsx(Box, { paddingX: "6px", marginBottom: "15px", children: _jsx(Slider, { disabled: !canCreateStudy, disableSwap: true, size: "small", min: MIN_AGE, max: MAX_AGE, marks: MARKS, value: sliderValues, valueLabelDisplay: "auto", onChange: handleAgeRangeChange, sx: {
                        '& .MuiSlider-markLabel ': {
                            top: '35px',
                        },
                        '& .MuiSlider-track': {
                            height: '3px',
                        },
                    } }) })] }));
};
